import axios from "../../../axios"
import { getCurrentTenant, parseObjectParamsToString } from '@/utils'

export default {
  fetch(searchParams) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          customers ${parseObjectParamsToString(searchParams)} {
            total_pages,
            total_items,
            items {
              id,
              name,
              email,
              image,
              phone_number,
              open_field,
              is_favorite,
              is_blacklisted,
              is_blacklisted_sms,
              is_blacklisted_email,
              is_blacklisted_campaign,
              document_register,
              address,
              deleted_at,
              erp_id,
              has_valid_phone_number,
              hasOpenCosts,
              isBeingAttendedBy {
                user_id,
                instance_id,
                chat_ticket_id
              },
              customer_groups {
                group {
                  name,
                  color_tag
                },
                sheet_tags
              },
              erp {
                id,
                erp_id,
                erp_name,
                corporate_name
              },
              instance {
                id,
                name,
                nickname,
                color
              }
            }
          }
        }
      `
    })
  },
  fetchByCustomerGroup(searchParams) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          customers ${parseObjectParamsToString(searchParams)} {            
            total_pages,            
            total_items,            
            items {              
                id,              
                name,
                email,              
                phone_number           
            }          
          }        
      }
      `
    })
  },
  infos(customerId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          groupOfCustomerInfos (
            id: ${customerId}
          ) {
            id,
            name,
            email,
            image,
            is_favorite,
            phone_number,
            is_blacklisted,
            is_blacklisted_campaign
          }
        }
      `
    })
  },
  add({ customer, chosenGroups }) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          createCustomer (
            name: "${customer.name}",
            phone_number: "${customer.phone_number}",
            chosen_groups: [${chosenGroups.join(',')}],
            is_blacklisted: ${customer.is_blacklisted},
            ` + (!customer.image ? '' : `image: "${customer.image}",`) + `,
            ` + (customer.open_field === '' ? '' : `open_field: "${customer.open_field}",`) + `,
            ` + (customer.is_favorite === '' ? '' : `is_favorite: ${customer.is_favorite},`) + `,
            ` + (!customer.is_blacklisted_sms || customer.is_blacklisted_sms === '' ? '' : `is_blacklisted_sms: ${customer.is_blacklisted_sms},`) + `,
            ` + (!customer.is_blacklisted_email || customer.is_blacklisted_email === '' ? '' : `is_blacklisted_email: ${customer.is_blacklisted_email},`) + `,
            ` + (!customer.email || customer.email === '' ? '' : `email: ${customer.email},`) + `,
          ) {
            id,
            name,
            is_favorite,
            phone_number,
            is_blacklisted
          }
        }
      `
    })
  },
  newAttendanceToCustomer({ phoneNumber, instanceId }) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          newAttendanceToCustomer (
            phone_number: "${phoneNumber}",
            instance_id: ${instanceId}
          ) {
            id,
            name,
            image,
            phone_number,
            open_field,
            is_blacklisted,
            is_blacklisted_campaign,
            is_favorite,
            deleted_at,
            has_valid_phone_number,
            isBeingAttendedBy {
              user_id,
              instance_id,
              chat_ticket_id
            },
            customer_groups {
              group {
                name
              },
              sheet_tags
            }
          }
        }
      `
    })
  },
  update({ customer, chosenGroups }) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          updateCustomer (
            id: ${customer.id},
            name: "${customer.name}",
            phone_number: "${customer.phone_number}",
            email: ${customer.email === null || customer.email === '' ||  customer.email === undefined ? null: `"${customer.email}"`},
            document_register: ${customer.document_register === undefined ? 'null' : `"${customer.document_register}"`},
            chosen_groups: [${chosenGroups.join(',')}],
            is_blacklisted: ${customer.is_blacklisted},
            ` + (customer.open_field === '' ? '' : `open_field: "${customer.open_field}",`) + `,
            ` + (customer.is_favorite === '' ? '' : `is_favorite: ${customer.is_favorite},`) + `,
            ` + (!customer.is_blacklisted_sms || customer.is_blacklisted_sms === '' ? '' : `is_blacklisted_sms: ${customer.is_blacklisted_sms},`) + `,
            ` + (!customer.is_blacklisted_email || customer.is_blacklisted_email === '' ? '' : `is_blacklisted_email: ${customer.is_blacklisted_email},`) + `,
          ) {
            id,
            name,
            email,
            image,
            open_field,
            is_favorite,
            phone_number,
            is_blacklisted,
            is_blacklisted_sms,
            is_blacklisted_email,
            document_register
          }
        }
      `
    })
  },
  updateOpenField({ customer, chosenGroups = null }) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          updateCustomer (
            id: ${customer.id},
            name: "${customer.name}",
            phone_number: "${customer.phone_number}",
            is_blacklisted: ${customer.is_blacklisted},
            is_favorite: ${customer.is_favorite},
            open_field: "${customer.open_field}",
            chosen_groups: [${chosenGroups.join(',')}]
          ) {
            id,
            name,
            image,
            open_field,
            is_favorite,
            phone_number,
            is_blacklisted
          }
        }
      `
    })
  },
  customerNumberWithoutMask(customerId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          customerWithoutMask (
            id: ${customerId}
          )
        }
      `
    })
  },
  delete(customerId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          deleteCustomer (
            id: ${customerId}
          )
        }
      `
    })
  },
  softDelete(customerId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          softDeleteCustomer (
            id: ${customerId}
          )
        }
      `
    })
  },
  fetchUnchosen(searchParams, chosenCustomersIds) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          customers  (
            pagination_limit: ${searchParams['pagination_limit']}
            pagination_page: ${searchParams['pagination_page']}
            chosen_customers: [${chosenCustomersIds.join(',')}],
            deleted_at: null
          ) {
            total_pages,
            total_items,
            items {
              id,
              name,
              email,
              phone_number,
              is_blacklisted
            }
          }
        }
      `
    })
  },
  getCustomerTicketsSummary(customerId, paginationPage, orderBy) { 
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          chatTicketSummary (
            id: ${customerId},
            pagination_page: ${paginationPage},
            pagination_limit: ${3},
            order_by: "${orderBy}"
          ) {
            items {
              grade_at,
              closed_by,
              finished_at,
              reasonResponse,
              is_auto_finished,
              is_multiple_research,
              send_finished_message,
              finished_message_is_sent,
              user {
                name,
                image
              },
              instance {
                name
              }
            },
            total_items,
            total_pages
          }
        }
      `
    })
  },
  downloadListCustomers(instance_id, all_customers, split_into_spreadsheets, customers_by_start_date, customers_by_end_date, customers_by_instances) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          downloadCustomer  (
            instance_id: ${instance_id},
            all_customers: ${all_customers},
            split_into_spreadsheets: ${split_into_spreadsheets},
            customers_by_start_date: "${customers_by_start_date}",
            customers_by_end_date: "${customers_by_end_date}",
            customers_by_instances: ${customers_by_instances},
          )
        }
      `
    })
  },
  check(token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
      return axios.post('', {
        query: `
          mutation {
            checkCustomerEmail (
                  access_token_email: "${token}"
              )
          }
        `
    })
  },
}
